export default __webpack_public_path__ + "static/ds-theming-values-table-36f14137f95ab980458f569a105a1081.png";